import Root from 'Root/root'
import {
  ROLE_GUEST,
  ROLE_ADMIN
} from 'Constants/roles'
import { LocalStorage } from 'quasar'
import QuasarConfig from './quasar.config'

QuasarConfig()

export default {
  apiUrl: API_PREFIX,
  historyApi: false,
  version: VERSION,
  rootPath: ROOT_PATH,
  rootModule: Root,
  ymapsUrl: YMAPS,
  get mainModule() {
    const userRole = LocalStorage.getItem('userRole') ?? ROLE_GUEST
    switch (userRole) {
      case ROLE_ADMIN: return 'onboarding'
      default: return 'onboarding'
    }
  },
  module404: '404',
  import: module => import(`./modules/${module}/module`),
  modules: {
    auth: {
      module: 'PageAuth',
      roles: [ROLE_GUEST]
    },
    changepass: {
      module: 'PageChangePass',
      roles: [ROLE_GUEST, ROLE_ADMIN]
    },
    404: {
      module: 'Page404',
      roles: [ROLE_GUEST, ROLE_ADMIN]
    },
    loader: {
      global: true,
      module: 'Loader',
      roles: [ROLE_GUEST, ROLE_ADMIN]
    },
    onboarding: {
      module: 'Onboarding',
      roles: [ROLE_GUEST, ROLE_ADMIN]
    },
    story: {
      module: 'PageStory',
      roles: [ROLE_GUEST, ROLE_ADMIN]
    }
  }
}
